import { render, staticRenderFns } from "./informe.vue?vue&type=template&id=bb38dd48&scoped=true&"
import script from "./informe.vue?vue&type=script&lang=js&"
export * from "./informe.vue?vue&type=script&lang=js&"
import style0 from "./informe.vue?vue&type=style&index=0&id=bb38dd48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb38dd48",
  null
  
)

export default component.exports